import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import Datetime from "react-datetime";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import FornecedoresForm from "beaktShared/views/Cadastros/FornecedoresForm";

// icons
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloseIcon from '@material-ui/icons/Close';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import {transformValueFloattoFormated,transformValueFormatedtoFloat, MaskMoney, MaskDate,convertDate, MaskOnlyNumbersStart1, validateDate, getLocale, getStringFormatDate} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { formateDate } from "beaktShared/helpers/masks";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import selectmultTable from "assets/jss/BeaktShared/selectmultTable";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(selectmultTable);

export default function RecebimentoCompra() {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();
    const classes2 = useStyles2();

    const { register, handleSubmit, setValue, errors, setError, clearError, getValues } = useForm({mode: "onChange"});
    const [loading, setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [alert,setalert] = React.useState();
    const showAlert = (message, tipo) => {        
        setalert(<SweetAlert
          error={tipo=='error'?true:false}
          warning={tipo=='warning'?true:false}
          success={tipo=='success'?true:false}
          title={t('label.warning')}
          onConfirm={() => setalert(null)}
        >  
        <div dangerouslySetInnerHTML={{ __html: message}} /> 
        </SweetAlert> );
    };

    const [franquia, setfranquia] = React.useState(0);
    const LoadFranquia = () => {        
        let endPoint = "estabelecimentos/"+session.estabelecimentoId;        
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')            
            return false;
        } 
        setfranquia(result.data.franquiaId);
        return true;
        });
    };
    useEffect(() => {                
        LoadSelectTipoDespesa();
        loadSelectProdutos();
    }, [franquia]);

    const [totalCompra, settotalCompra] = React.useState(0);

    const [showFormViewFornecedores, setshowFormViewFornecedores] = React.useState(false);
    const handleViewFornecedores = () => {
        let show = showFormViewFornecedores === true ? false : true;
        setshowFormViewFornecedores(show);
    };
    const handleAddFornecedores = item => {
        if (session.estabelecimentoId === 0)
            item.franquiaId = session.franquiaId;            
        else{
            item.estabelecimentoFornecedores = [];
            item.estabelecimentoFornecedores.push({
                estabelecimentoId: session.estabelecimentoId
            });
        }

        setloading(true);        
        UsePostApi('fornecedores/', item).then(result => {
            setloading(false);
            if (result.status !== 201) {
                showNotification(result.message, 'danger');
                return false;
            }

            const addItemList = [...listSelectFornecedor, result.data];
            setlistSelectFornecedor(addItemList);
            setfornecedor(result.data.fornecedorId);
            handleViewFornecedores();
            showNotification(t('information_message.registered_successfully'), 'success');
            return true;
        });        
        return false;
    };

    const [fornecedor, setfornecedor] = React.useState(0);
    const [listSelectFornecedor, setlistSelectFornecedor] = React.useState([]);
    const [loadingSelectFornecedor, setloadingSelectFornecedor] = React.useState(false);    
    const LoadSelectFornecedor = () =>{   
        setloadingSelectFornecedor(true);      
        let endPoint = "fornecedores/ativos/";
        if (session.estabelecimentoId === 0)
            endPoint += "byfranquia/"+ session.franquiaId;
        else
            endPoint += "byestabelecimento/"+ session.estabelecimentoId;

        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setloadingSelectFornecedor(false); 
                return false; 
            }              
            setlistSelectFornecedor(result.data);
            setloadingSelectFornecedor(false); 
            return true;                
        });  
    }    
    const handleFornecedorChange = (event) => {
        let value = event
        setfornecedor(value);
    }

    const [tipoDespesa, settipoDespesa] = React.useState(0);
    const [listSelectTipoDespesa, setlistSelectTipoDespesa] = React.useState([]);
    const [loadingSelectTipoDespesa, setloadingSelectTipoDespesa] = React.useState(false);    
    const LoadSelectTipoDespesa = () =>{   
        setloadingSelectTipoDespesa(true);     
        const endPoint = "tipodespesa/byfranquia/"+ franquia;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setloadingSelectTipoDespesa(false); 
                return false; 
            }  
            setlistSelectTipoDespesa(result.data);
            setloadingSelectTipoDespesa(false); 
            return true;                
        });  
    }
    const handleTipoDespesaChange = (event) => {
        let value = event
        settipoDespesa(value);
    }
    
    const [produto, setproduto] = React.useState(0);
    const [listSelectProdutos, setlistSelectProdutos] = React.useState([]);
    const [loadingSelectProdutos, setloadingSelectProdutos] = React.useState(false);   
    const loadSelectProdutos = () =>{           
        setloadingSelectProdutos(true);     
        let endPoint = "produtos/ativos/";
        if (session.estabelecimentoId === 0)
            endPoint += "byfranquia/" + session.franquiaId;
        else
            endPoint += "byestabelecimento/" + session.estabelecimentoId;

        UseGetApiSimple(endPoint,0).then(result=>{                   
            if(result.status !== 200)
            {                                                     
                setloadingSelectProdutos(false); 
                return false; 
            }  
            
            let newlist = [];

            for (var i in result.data){
                newlist.push({
                    produtoId: result.data[i].produtoId,
                    descricao: result.data[i].descricao + 
                               " (" +
                               transformValueFloattoFormated(result.data[i].valor) +
                               ")"
                });
            }

            setlistSelectProdutos(newlist);  
            setloadingSelectProdutos(false); 
            return true;                
        });  
    }
    const handleProdutoChange = event => {                
        let valor = transformValueFloattoFormated(event.valorCusto);
        setValue("custounitario",valor);
        setValue("qtd", 1);
        setproduto(event);        
    }; 

    const [custoTotalItem, setcustoTotalItem] = React.useState("0"); 
    const calculaCustoItem = () =>{        
        let data = getValues();
        setcustoTotalItem(transformValueFloattoFormated(parseInt(data.qtd) * transformValueFormatedtoFloat(data.custounitario)));
    }

    const [listProdutosAdicionados, setlistProdutosAdicionados] = React.useState([]);
    const handleAddItem = () => {
        let data = getValues();
        
        if (produto === ""){
            setError("produto","required");
            return;
        }

        if (transformValueFormatedtoFloat(data.custounitario) === 0){
            setError("custounitario","required");
            return;
        }

        if (parseInt(data.qtd) === 0){
            setError("qtd","required");
            return;
        }
        
        clearError();

        let newItem = {
            produtoId: produto.produtoId,
            descricao: produto.descricao,
            qtd: parseInt(data.qtd),
            custoUnitario: transformValueFormatedtoFloat(data.custounitario),
            custoTotal: (parseInt(data.qtd) * transformValueFormatedtoFloat(data.custounitario))
        }

        settotalCompra(totalCompra + newItem.custoTotal);
        const addItemList = [...listProdutosAdicionados, newItem];
        setlistProdutosAdicionados(addItemList);

        setValue("qtd", "1");
        setValue("custounitario", "0");        
        setproduto("");
    }

    const handleDeleteItem = (item) => {        
        let newList = listProdutosAdicionados.filter(function(f){return f != item});
        setlistProdutosAdicionados(newList);
        settotalCompra(totalCompra - item.custoTotal);
    }

    useEffect(() => {         
        calculaCustoItem();
    }, [produto]);

    const [dtvencimento,setdtvencimento] = React.useState(new Date());
    const [dtrecebimento,setdtrecebimento] = React.useState(new Date());
    useEffect(() => {         
        LoadSelectFornecedor();    

        if (session.estabelecimentoId === 0){
            setfranquia(session.franquiaId);            
        }
        else{
            LoadFranquia();
        }                
        
    }, []);

    const validaCampos = data =>{
        let existerror = false;
        
        if (fornecedor === 0 || fornecedor === ""){
            setError("fornecedor","required");
            existerror = true;
        }

        if (tipoDespesa === 0 || tipoDespesa === ""){
            setError("tipodespesa","required");
            existerror = true;
        }

        if (data.dtvencimento.length !== 10){
            setError("dtvencimento","required");
            existerror = true;
        }

        if (data.dtrecebimento.length !== 10){
            setError("dtrecebimento","required");
            existerror = true;
        }

        if (data.documento.length === 0){
            setError("documento","required");
            existerror = true;
        }

        if (data.parcelas.length === 0){
            setError("parcelas","required");
            existerror = true;
        }
        
        if (!validateDate(data.dtrecebimento)){
            setError("dtrecebimento","invaliddate", "Data inválida!");
            existerror = true;
        }

        if (!validateDate(data.dtvencimento)){
            setError("dtvencimento","invaliddate", "Data inválida!");
            existerror = true;
        }

        if (listProdutosAdicionados.length === 0){
            showAlert(t('information_message.fill_the_products'), "warning");
            existerror = true;
        }

        return existerror;
    };

    const onSubmit = data => {  
        if (loading) return false;
        if(validaCampos(data)) return false;
        
        var dtrecebimento_date = convertDate(dtrecebimento);
        var dtvencimento_date = convertDate(dtvencimento);        

        let estoque = [];

        for(var i in listProdutosAdicionados){
            let movimento = {
                produtoId: listProdutosAdicionados[i].produtoId,
                quantidade: listProdutosAdicionados[i].qtd,
                usuarioMovimentoId: session.id,
                valorProduto: listProdutosAdicionados[i].custoUnitario
            };
            if (session.estabelecimentoId != 0)
                movimento.estabelecimentoId = session.estabelecimentoId;

            estoque.push(movimento);
        }

        let contapagar = {            
            fornecedorId: fornecedor,
            dataRecebimento: dtrecebimento_date,
            dataVencimento: dtvencimento_date,
            titulo: data.documento,
            valorConta: totalCompra,
            usuarioCadastroId: session.id,
            tipoDespesaId: tipoDespesa
        }
        if (session.estabelecimentoId === 0)
            contapagar.franquiaId = session.franquiaId;
        else
            contapagar.estabelecimentoId = session.estabelecimentoId;

        let dados = {
            quantidadeParcelas: data.parcelas,
            contaPagar: contapagar,
            estoqueMovimento: estoque
        }

        setloading(true);
        let endpoint = "";
        if (session.estabelecimentoId === 0)
            endpoint = "RecebimentoCompraMatriz";
        else
            endpoint = "EstoqueClinica";
            
        UsePostApi(endpoint, dados).then( result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }            
            showAlert("Entrada de estoque realizada com sucesso!", "success");                                         
            clearValues();
            return true;
        });
    }

    const clearValues = () => {
        setfornecedor(0);
        settipoDespesa(0);
        setdtrecebimento(new Date());
        setdtvencimento(new Date());
        setValue("documento", "");
        setValue("parcelas", "");
        setValue("qtd", "1");
        setValue("custounitario", "0");        
        setproduto("");
        setlistProdutosAdicionados([]);
        settotalCompra(0);
    }

    return (
        <div className="maxContent">    
            {showFormViewFornecedores &&
                <FornecedoresForm addItem={handleAddFornecedores} item={{}} handleView={handleViewFornecedores} loading={loading} />}         
            <form onSubmit={handleSubmit(onSubmit)}>
            {notification.show &&
                <div><br/>
                <SnackbarContent
                    message={notification.message}
                    color={notification.color}
                    closeNotification={() => setNotification({show:false})}
                    close
                /></div>}

            {!showFormViewFornecedores &&
                <div>
                    {loading && 
                        <div className="carregandoCmp">
                            <div className="box">
                                <label>{t('label.loading')}...</label>
                                <CircularProgress />
                            </div>
                        </div> 
                    }
                    <div>                    
                        <GridContainer>                        
                            {alert}
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <ShoppingCartIcon />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                        {t('stock.product_purchase_receipt')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={9}>                                                    
                                                <FormControl fullWidth className={classes.formControl}>                                    
                                                    <label className={errors.fornecedor ? "select__label select__label_error" : "select__label"}>
                                                    {t('label.supplier')} * 
                                                    </label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.fornecedor ? true : false)}
                                                        isSearchable={true}
                                                        isLoading={loadingSelectFornecedor}
                                                        name="fornecedor"
                                                        placeholder={t('label.select')+"..."}
                                                        options={listSelectFornecedor}
                                                        value={listSelectFornecedor.filter(({ fornecedorId }) => fornecedorId === fornecedor)}
                                                        getOptionLabel={({ fantasia }) => fantasia}
                                                        getOptionValue={({ fornecedorId }) => fornecedorId}
                                                        onChange={(value) => handleFornecedorChange(value.fornecedorId !== null ? value.fornecedorId : "")}
                                                        ref={() => register({ name: "fornecedor" })
                                                        }
                                                    />
                                                    {errors.fornecedor &&
                                                    <FormHelperText>
                                                        <span className="obg"> {t('label.required')} </span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>    
                                            <GridItem xs={12} sm={6} md={3}>
                                                <Button simple color="info" onClick={() => handleViewFornecedores()}>
                                                    {t('button.add_new_supplier')}
                                                </Button>
                                            </GridItem>                                
                                            <GridItem xs={12} sm={6} md={6}>                
                                                <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.tipodespesa ? "select__label select__label_error" : "select__label"}>
                                                    {t('label.expense_type')} * </label>
                                                <Select
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.tipodespesa ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={loadingSelectTipoDespesa}
                                                    name="tipodespesa"
                                                    placeholder={t('label.select')+"..."}
                                                    options={listSelectTipoDespesa}
                                                    value={listSelectTipoDespesa.filter(({ tipoDespesaId }) => tipoDespesaId === tipoDespesa)}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ tipoDespesaId }) => tipoDespesaId}
                                                    onChange={(value) => handleTipoDespesaChange(value.tipoDespesaId !== null ? value.tipoDespesaId : "")}
                                                    ref={() => register({ name: "tipodespesa" })
                                                    }
                                                />
                                                {errors.tipodespesa &&
                                                <FormHelperText>
                                                    <span className="obg"> {t('label.required')}</span>
                                                </FormHelperText>}
                                                </FormControl>                    
                                            </GridItem>  
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>                                                               
                                                    <label className={errors.dtvencimento?"select__label select__label_error":"select__label"}>
                                                        {t('label.due_date')+" *"}  </label>
                                                    <Datetime                                    
                                                        locale={getLocale()}
                                                        dateFormat={getStringFormatDate()}
                                                        timeFormat={false}                                    
                                                        name="dtvencimento"                                      
                                                        defaultValue={dtvencimento}
                                                        value={dtvencimento}
                                                        onChange={date => { setdtvencimento(date) }}
                                                        inputProps={{name:"dtvencimento", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                                        className={errors.dtvencimento?"error":""}            
                                                    />       
                                                    {errors.dtvencimento && <FormHelperText className={classes.labelRootError}>
                                                        <span> {errors.dtvencimento.message} </span>                                                                          
                                                    </FormHelperText>} 
                                                </FormControl>                                                                 
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>                                                               
                                                    <label className={errors.dtrecebimento?"select__label select__label_error":"select__label"}>
                                                        {t('label.receipt_date')+" *"}  </label>
                                                    <Datetime                                    
                                                        locale={getLocale()}
                                                        dateFormat={getStringFormatDate()}
                                                        timeFormat={false}                                    
                                                        name="dtrecebimento"                                      
                                                        defaultValue={dtrecebimento}
                                                        value={dtrecebimento}
                                                        onChange={date => { setdtrecebimento(date) }}
                                                        inputProps={{name:"dtrecebimento", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                                        className={errors.dtrecebimento?"error":""}            
                                                    />       
                                                    {errors.dtrecebimento && <FormHelperText className={classes.labelRootError}>
                                                        <span> {errors.dtrecebimento.message} </span>                                                                          
                                                    </FormHelperText>} 
                                                </FormControl>                                                                 
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.documento?true:false}
                                                        variant="outlined"
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.document_number')+" *"}
                                                        name="documento"
                                                        inputProps={{maxLength: 30}} 
                                                        InputLabelProps={{shrink: true}}                                            
                                                    />
                                                    {errors.documento && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.documento.message }</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.parcelas?true:false}
                                                        variant="outlined"
                                                        type="number"
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.qty_parcel')+" *"}
                                                        name="parcelas"       
                                                        onInput={(e) => MaskOnlyNumbersStart1(e) }                                         
                                                        InputLabelProps={{shrink: true}}                                            
                                                    />
                                                    {errors.parcelas && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.parcelas.message}</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>                
                                            <div className="subTitulo"> 
                                                <h6>{t('stock.add_purchased_products')}</h6>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} sm={6} md={4}>                
                                                <FormControl fullWidth className={classes.formControl}>
                                                <label className={errors.produto ? "select__label select__label_error" : "select__label"}>
                                                {t('label.product')} *</label>
                                                <Select
                                                    classNamePrefix="select"
                                                    styles={ValidSelect(errors.produto ? true : false)}
                                                    isSearchable={true}
                                                    isLoading={loadingSelectProdutos}
                                                    name="produto"
                                                    placeholder={t('label.select')+"..."}
                                                    options={listSelectProdutos}
                                                    value={listSelectProdutos.filter(({ produtoId }) => produtoId === produto.produtoId)}
                                                    getOptionLabel={({ descricao }) => descricao}
                                                    getOptionValue={({ produtoId }) => produtoId}
                                                    onChange={(value) => handleProdutoChange(value)}
                                                    ref={() => register({ name: "produto" })
                                                    }
                                                />
                                                {errors.produto &&
                                                <FormHelperText>
                                                    <span className="obg"> {t('label.required')} </span>
                                                </FormHelperText>}
                                                </FormControl>                    
                                            </GridItem>   
                                            <GridItem xs={12} sm={6} md={2}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.qtd?true:false}
                                                        variant="outlined"
                                                        type="number"
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.qty')+" *"}
                                                        name="qtd"       
                                                        defaultValue="1" 
                                                        onInput={(e) => MaskOnlyNumbersStart1(e) }
                                                        onChange={(value) => calculaCustoItem()}
                                                        InputLabelProps={{shrink: true}}                                            
                                                    />
                                                    {errors.qtd && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.qtd.message }</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={2}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.custounitario?true:false}
                                                        variant="outlined"                                  
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.unitary')+" *"}
                                                        name="custounitario"
                                                        defaultValue="0"
                                                        InputProps={{ inputComponent: MaskMoney}}
                                                        onChange={(value) => calculaCustoItem()}
                                                        InputLabelProps={{shrink: true}}                                            
                                                    />
                                                    {errors.custounitario && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.custounitario.message }</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={2}>
                                                <label>{t('label.total')}:</label><br/>
                                                <label><strong> {t('label.money_symbol')} {custoTotalItem}</strong></label>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={1}>
                                                <Button color="primary" justIcon onClick={() => handleAddItem()}>
                                                    <AddBoxIcon />
                                                </Button>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>                                                                                                         
                                                {listProdutosAdicionados.length > 0 &&
                                                <div>
                                                    <h5>{t('register.product_list')}</h5>                                                  
                                                    <div className={classes2.boxSelectedBefore}>                                                    
                                                        <table style={{width:"100%"}}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{width:"10%"}}>{t('label.actions')}</th>
                                                                    <th style={{width:"50%"}}> <b> {t('label.product')}</b> </th>
                                                                    <th style={{width:"10%", textAlign:"right"}}> <b> {t('label.qty')}</b> </th>
                                                                    <th style={{width:"15%", textAlign:"right"}}> <b> {t('label.unitary')}</b> </th>
                                                                    <th style={{width:"15%", textAlign:"right"}}> <b> {t('label.total')}</b> </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            {listProdutosAdicionados.map(item => (     
                                                                <tr style={{marginBottom:"10%"}} key={item.id}>
                                                                    <td>
                                                                        <Button size="sm" justIcon color="danger" onClick={() => handleDeleteItem(item)}>
                                                                            <CloseIcon />
                                                                        </Button>
                                                                    </td>
                                                                    <td style={{width:"50%"}}>{item.descricao}
                                                                    </td>
                                                                    <td style={{width:"10%", textAlign:"right"}}>{item.qtd}
                                                                    </td>
                                                                    <td style={{width:"15%", textAlign:"right"}}>{transformValueFloattoFormated(item.custoUnitario)}
                                                                    </td>
                                                                    <td style={{width:"15%", textAlign:"right"}}>{transformValueFloattoFormated(item.custoTotal)}
                                                                    </td>
                                                                </tr>
                                                            ))}                                               
                                                            </tbody>
                                                        </table>
                                                        <br/>                                                    
                                                    </div>   
                                                    <h5 style={{textAlign:"right"}}><strong>{t('label.total')}: {t('label.money_symbol')} {transformValueFloattoFormated(totalCompra)} </strong></h5>
                                                </div>  
                                                }                                         
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>                                                                                                              
                        </GridContainer>                        
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                <br/>
                                <div className={classes.textCenter}>
                                    <Button  color="transparent" className={classes.updateProfileButton} onClick={() => clearValues()}>
                                        {t('button.cancel')} 
                                    </Button>
                                    <Button 
                                        type="submit" 
                                        color="primary" 
                                        className={classes.updateProfileButton}
                                        disabled={loading}>
                                        {t('button.to_save')}                              
                                    </Button>
                                </div>
                            </GridItem>
                        </GridContainer>  
                    </div>
                </div>
            }          
            </form>
        </div>
    );
}